import styled from 'styled-components'

const Wrapper = styled.div`
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
`
export default Wrapper
